import BusinessCardIcon from "assets/img/support/typcn_business-card.svg";
import ServicesIcon from "assets/img/support/services.svg";
import GroupSolarIcon from "assets/img/support/group-solar.svg";
import GroupProfileIcon from "assets/img/support/group-profile.svg";
import CommunicationIcon from "assets/img/support/communication.svg";

export const resourceCards = [
  {
    id: "billing",
    icon: GroupSolarIcon,
    title: "Billing and payments",
    description: "Manage payments, invoices, and billing information.",
    link: "#",
  },
  {
    id: "account",
    icon: GroupProfileIcon,
    title: "Account and profile",
    description: "Update your personal information and security settings.",
    link: "#",
  },
  {
    id: "team",
    icon: BusinessCardIcon,
    title: "Team and business accounts",
    description: "Collaborate with your team and manage permissions.",
    link: "#",
  },
  {
    id: "translation",
    icon: ServicesIcon,
    title: "Translation services",
    description: "Learn about our translation types and document options.",
    link: "#",
  },
  {
    id: "support",
    icon: CommunicationIcon,
    title: "Support and communication",
    description: "Get help from our support team and project managers.",
    link: "#",
  },
];
